import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '@env/environment';
import { ExistsResponse, IResponse } from '@core/models/general';
import { User } from '@core/models/user';
import {
  RefCodeData,
  RefcodeValidateResponse,
  ReferralParentItem,
  ReferredItem,
} from '@core/models/iocoins';

@Injectable({ providedIn: 'root' })
export class IocoinsReferralService {
  private readonly http = inject(HttpClient);

  readonly url = `${environment.api.baseUrl}/iocoins-referral`;

  findOneByRefCode(refCode: string): Observable<User> {
    return this.http
      .get<IResponse<User>>(`${this.url}/refcode/${encodeURIComponent(refCode)}`)
      .pipe(map(response => response.data));
  }

  refcodeExists(refCode: string) {
    return this.http
      .get<IResponse<ExistsResponse>>(`${this.url}/refcode/${refCode}/exists`)
      .pipe(map(response => response.data));
  }

  refcodeData(refCode: string) {
    return this.http
      .get<IResponse<RefCodeData>>(`${this.url}/refcode/${refCode}`)
      .pipe(map(response => response.data));
  }

  getMyReferral(): Observable<ReferredItem[]> {
    return this.http
      .get<IResponse<ReferredItem[]>>(`${this.url}/me/referidores`)
      .pipe(map(response => response.data));
  }

  getMyReferralParent(): Observable<ReferralParentItem> {
    return this.http
      .get<IResponse<ReferralParentItem>>(`${this.url}/me/parent`)
      .pipe(map(response => response.data));
  }

  refcodeValidateFromUser(refCode: string): Observable<RefcodeValidateResponse> {
    return this.http
      .get<IResponse<RefcodeValidateResponse>>(`${this.url}/me/refcode/${refCode}/validate`)
      .pipe(map(response => response.data));
  }

  refcodeAcceptFromUser(refCode: string): Observable<User> {
    return this.http
      .post<IResponse<User>>(`${this.url}/me/refcode/${refCode}/accept`, {})
      .pipe(map(response => response.data));
  }
}
